// @ts-nocheck
/* eslint-disable */
/**
 * Generated by orval v8.13.0 🍺
 * Do not edit manually.
 * SUREnet crm-public API
 * OpenAPI spec version: 1
 */
import { useMutation } from '@tanstack/vue-query';
import type {
  MutationFunction,
  QueryClient,
  UseMutationOptions,
  UseMutationReturnType,
} from '@tanstack/vue-query';

import { unref } from 'vue';
import type { MaybeRef } from 'vue';

import type { CrmRelationsContactpersoonDto } from '../model/crmRelationsContactpersoonDto';

import { customInstance } from '../../customInstance';
import type { ErrorType } from '../../customInstance';

type SecondParameter<T extends (...args: never) => unknown> = Parameters<T>[1];

/**
 *  <br /> Required permissions:<br /> <ul> <li>Permission: Crm.RelatieAanmaken</li></ul>
 * @summary Maak een nieuwe contactpersoon aan voor een relatie
 */
export const relatieContactpersonenMaakRelatieContactPersoon = (
  relatienummer: MaybeRef<number | undefined | null>,
  crmRelationsContactpersoonDto?: MaybeRef<CrmRelationsContactpersoonDto>,
  options?: SecondParameter<typeof customInstance>,
  signal?: AbortSignal,
) => {
  relatienummer = unref(relatienummer);
  crmRelationsContactpersoonDto = unref(crmRelationsContactpersoonDto);

  return customInstance<string>(
    {
      url: `/api/v1/relaties/${relatienummer}/contactpersonen`,
      method: 'POST',
      headers: { 'Content-Type': 'application/json-patch+json' },
      data: crmRelationsContactpersoonDto,
      signal,
    },
    options,
  );
};

export const getRelatieContactpersonenMaakRelatieContactPersoonMutationOptions = <
  TError = ErrorType<void>,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof relatieContactpersonenMaakRelatieContactPersoon>>,
    TError,
    { relatienummer: number | undefined | null; data?: CrmRelationsContactpersoonDto },
    TContext
  >;
  request?: SecondParameter<typeof customInstance>;
}): UseMutationOptions<
  Awaited<ReturnType<typeof relatieContactpersonenMaakRelatieContactPersoon>>,
  TError,
  { relatienummer: number | undefined | null; data?: CrmRelationsContactpersoonDto },
  TContext
> => {
  const mutationKey = ['relatieContactpersonenMaakRelatieContactPersoon'];
  const { mutation: mutationOptions, request: requestOptions } = options
    ? options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey
      ? options
      : { ...options, mutation: { ...options.mutation, mutationKey } }
    : { mutation: { mutationKey }, request: undefined };

  const mutationFn: MutationFunction<
    Awaited<ReturnType<typeof relatieContactpersonenMaakRelatieContactPersoon>>,
    { relatienummer: number | undefined | null; data?: CrmRelationsContactpersoonDto }
  > = (props) => {
    const { relatienummer, data } = props ?? {};

    return relatieContactpersonenMaakRelatieContactPersoon(relatienummer, data, requestOptions);
  };

  return { mutationFn, ...mutationOptions };
};

export type RelatieContactpersonenMaakRelatieContactPersoonMutationResult = NonNullable<
  Awaited<ReturnType<typeof relatieContactpersonenMaakRelatieContactPersoon>>
>;
export type RelatieContactpersonenMaakRelatieContactPersoonMutationBody =
  | CrmRelationsContactpersoonDto
  | undefined;
export type RelatieContactpersonenMaakRelatieContactPersoonMutationError = ErrorType<void>;

/**
 * @summary Maak een nieuwe contactpersoon aan voor een relatie
 */
export const useRelatieContactpersonenMaakRelatieContactPersoon = <
  TError = ErrorType<void>,
  TContext = unknown,
>(
  options?: {
    mutation?: UseMutationOptions<
      Awaited<ReturnType<typeof relatieContactpersonenMaakRelatieContactPersoon>>,
      TError,
      { relatienummer: number | undefined | null; data?: CrmRelationsContactpersoonDto },
      TContext
    >;
    request?: SecondParameter<typeof customInstance>;
  },
  queryClient?: QueryClient,
): UseMutationReturnType<
  Awaited<ReturnType<typeof relatieContactpersonenMaakRelatieContactPersoon>>,
  TError,
  { relatienummer: number | undefined | null; data?: CrmRelationsContactpersoonDto },
  TContext
> => {
  return useMutation(
    getRelatieContactpersonenMaakRelatieContactPersoonMutationOptions(options),
    queryClient,
  );
};
/**
 *  <br /> Required permissions:<br /> <ul> <li>Permission: Crm.RelatieBijwerken</li></ul>
 * @summary Werkt een contactpersoon van een relatie bij
 */
export const relatieContactpersonenMuteerRelatieContactPersoon = (
  relatienummer: MaybeRef<number | undefined | null>,
  contactpersoonId: MaybeRef<string | undefined | null>,
  crmRelationsContactpersoonDto?: MaybeRef<CrmRelationsContactpersoonDto>,
  options?: SecondParameter<typeof customInstance>,
  signal?: AbortSignal,
) => {
  relatienummer = unref(relatienummer);
  contactpersoonId = unref(contactpersoonId);
  crmRelationsContactpersoonDto = unref(crmRelationsContactpersoonDto);

  return customInstance<void>(
    {
      url: `/api/v1/relaties/${relatienummer}/contactpersonen/${contactpersoonId}`,
      method: 'PUT',
      headers: { 'Content-Type': 'application/json-patch+json' },
      data: crmRelationsContactpersoonDto,
      signal,
    },
    options,
  );
};

export const getRelatieContactpersonenMuteerRelatieContactPersoonMutationOptions = <
  TError = ErrorType<void>,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof relatieContactpersonenMuteerRelatieContactPersoon>>,
    TError,
    {
      relatienummer: number | undefined | null;
      contactpersoonId: string | undefined | null;
      data?: CrmRelationsContactpersoonDto;
    },
    TContext
  >;
  request?: SecondParameter<typeof customInstance>;
}): UseMutationOptions<
  Awaited<ReturnType<typeof relatieContactpersonenMuteerRelatieContactPersoon>>,
  TError,
  {
    relatienummer: number | undefined | null;
    contactpersoonId: string | undefined | null;
    data?: CrmRelationsContactpersoonDto;
  },
  TContext
> => {
  const mutationKey = ['relatieContactpersonenMuteerRelatieContactPersoon'];
  const { mutation: mutationOptions, request: requestOptions } = options
    ? options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey
      ? options
      : { ...options, mutation: { ...options.mutation, mutationKey } }
    : { mutation: { mutationKey }, request: undefined };

  const mutationFn: MutationFunction<
    Awaited<ReturnType<typeof relatieContactpersonenMuteerRelatieContactPersoon>>,
    {
      relatienummer: number | undefined | null;
      contactpersoonId: string | undefined | null;
      data?: CrmRelationsContactpersoonDto;
    }
  > = (props) => {
    const { relatienummer, contactpersoonId, data } = props ?? {};

    return relatieContactpersonenMuteerRelatieContactPersoon(
      relatienummer,
      contactpersoonId,
      data,
      requestOptions,
    );
  };

  return { mutationFn, ...mutationOptions };
};

export type RelatieContactpersonenMuteerRelatieContactPersoonMutationResult = NonNullable<
  Awaited<ReturnType<typeof relatieContactpersonenMuteerRelatieContactPersoon>>
>;
export type RelatieContactpersonenMuteerRelatieContactPersoonMutationBody =
  | CrmRelationsContactpersoonDto
  | undefined;
export type RelatieContactpersonenMuteerRelatieContactPersoonMutationError = ErrorType<void>;

/**
 * @summary Werkt een contactpersoon van een relatie bij
 */
export const useRelatieContactpersonenMuteerRelatieContactPersoon = <
  TError = ErrorType<void>,
  TContext = unknown,
>(
  options?: {
    mutation?: UseMutationOptions<
      Awaited<ReturnType<typeof relatieContactpersonenMuteerRelatieContactPersoon>>,
      TError,
      {
        relatienummer: number | undefined | null;
        contactpersoonId: string | undefined | null;
        data?: CrmRelationsContactpersoonDto;
      },
      TContext
    >;
    request?: SecondParameter<typeof customInstance>;
  },
  queryClient?: QueryClient,
): UseMutationReturnType<
  Awaited<ReturnType<typeof relatieContactpersonenMuteerRelatieContactPersoon>>,
  TError,
  {
    relatienummer: number | undefined | null;
    contactpersoonId: string | undefined | null;
    data?: CrmRelationsContactpersoonDto;
  },
  TContext
> => {
  return useMutation(
    getRelatieContactpersonenMuteerRelatieContactPersoonMutationOptions(options),
    queryClient,
  );
};
/**
 *  <br /> Required permissions:<br /> <ul> <li>Permission: Crm.RelatieBijwerken</li></ul>
 * @summary Verwijdert een contactpersoon van een relatie
 */
export const relatieContactpersonenVerwijderRelatieContactPersoon = (
  relatienummer: MaybeRef<number | undefined | null>,
  contactpersoonId: MaybeRef<string | undefined | null>,
  options?: SecondParameter<typeof customInstance>,
  signal?: AbortSignal,
) => {
  relatienummer = unref(relatienummer);
  contactpersoonId = unref(contactpersoonId);

  return customInstance<void>(
    {
      url: `/api/v1/relaties/${relatienummer}/contactpersonen/${contactpersoonId}`,
      method: 'DELETE',
      signal,
    },
    options,
  );
};

export const getRelatieContactpersonenVerwijderRelatieContactPersoonMutationOptions = <
  TError = ErrorType<void>,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof relatieContactpersonenVerwijderRelatieContactPersoon>>,
    TError,
    { relatienummer: number | undefined | null; contactpersoonId: string | undefined | null },
    TContext
  >;
  request?: SecondParameter<typeof customInstance>;
}): UseMutationOptions<
  Awaited<ReturnType<typeof relatieContactpersonenVerwijderRelatieContactPersoon>>,
  TError,
  { relatienummer: number | undefined | null; contactpersoonId: string | undefined | null },
  TContext
> => {
  const mutationKey = ['relatieContactpersonenVerwijderRelatieContactPersoon'];
  const { mutation: mutationOptions, request: requestOptions } = options
    ? options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey
      ? options
      : { ...options, mutation: { ...options.mutation, mutationKey } }
    : { mutation: { mutationKey }, request: undefined };

  const mutationFn: MutationFunction<
    Awaited<ReturnType<typeof relatieContactpersonenVerwijderRelatieContactPersoon>>,
    { relatienummer: number | undefined | null; contactpersoonId: string | undefined | null }
  > = (props) => {
    const { relatienummer, contactpersoonId } = props ?? {};

    return relatieContactpersonenVerwijderRelatieContactPersoon(
      relatienummer,
      contactpersoonId,
      requestOptions,
    );
  };

  return { mutationFn, ...mutationOptions };
};

export type RelatieContactpersonenVerwijderRelatieContactPersoonMutationResult = NonNullable<
  Awaited<ReturnType<typeof relatieContactpersonenVerwijderRelatieContactPersoon>>
>;

export type RelatieContactpersonenVerwijderRelatieContactPersoonMutationError = ErrorType<void>;

/**
 * @summary Verwijdert een contactpersoon van een relatie
 */
export const useRelatieContactpersonenVerwijderRelatieContactPersoon = <
  TError = ErrorType<void>,
  TContext = unknown,
>(
  options?: {
    mutation?: UseMutationOptions<
      Awaited<ReturnType<typeof relatieContactpersonenVerwijderRelatieContactPersoon>>,
      TError,
      { relatienummer: number | undefined | null; contactpersoonId: string | undefined | null },
      TContext
    >;
    request?: SecondParameter<typeof customInstance>;
  },
  queryClient?: QueryClient,
): UseMutationReturnType<
  Awaited<ReturnType<typeof relatieContactpersonenVerwijderRelatieContactPersoon>>,
  TError,
  { relatienummer: number | undefined | null; contactpersoonId: string | undefined | null },
  TContext
> => {
  return useMutation(
    getRelatieContactpersonenVerwijderRelatieContactPersoonMutationOptions(options),
    queryClient,
  );
};
